import React, { Component } from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import moment from 'moment';
import _ from 'lodash';
import {
  Button,
  Layout,
  notification,
  Select,
  Steps,
  Row,
  Col,
} from 'antd/lib';
const Option = Select.Option;
import * as Icons from '@ant-design/icons';

import ProcesoImprimir from '../../procesos/ProcesoImprimir';

import getAcuerdoExtrajudicialPorId from '../../../graphql/querys/arreglosExtrajudiciales/getAcuerdoExtrajudicialPorId.graphql';
import agregarDocumento from '../../../graphql/mutations/arreglosExtrajudiciales/agregarDocumento.graphql';
import insertDocumento from '../../../graphql/mutations/common/insertDocumento.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};
@compose(
  graphql(insertDocumento, {
    name: 'insertDocumento',
  }),
  graphql(agregarDocumento, {
    name: 'agregarDocumento',
  })
)
class AgregarDocumento extends Component {
  state = {
    acuerdo: {},
    step: 0,
    requirenteSeleccionado: [],
    requeridosSeleccionados: [],
  };

  componentDidMount() {
    if (this.props.match.params) {
      let _id = this.props.match.params.id;

      if (_id) {
        this.props.client
          .query({
            query: getAcuerdoExtrajudicialPorId,
            variables: { _id: _id },
          })
          .then(res => {
            let acuerdo = res.data.getAcuerdoExtrajudicialPorId;
            this.setState({
              acuerdo,
            });
          })
          .catch(err => {
            console.log(
              'Error en la obtencion de los datos completos del acuerdo extrajudicial'
            );
            console.log(err);
          });
      }
    }
  }

  generarDatos = () => {
    const {
      acuerdo,
      requirenteSeleccionado,
      requeridosSeleccionados,
    } = this.state;

    acuerdo.anio = moment(acuerdo.fechaCreacion).format('YYYY');

    const { numero, organismo, motivo } = acuerdo;
    const datos = {
      acuerdo,
      numero,
      organismo,
      motivo,
    };

    if (requirenteSeleccionado.length > 0) {
      datos.requirente = acuerdo.requirente;
    }

    if (requeridosSeleccionados.length > 0) {
      requeridosSeleccionados.map((elem, index) => {
        const requerido = acuerdo.requeridos.find(
          requerido => requerido._id === elem
        );

        if (requerido) datos[`requerido${index + 1}`] = requerido;
      });
    }

    return datos;
  };

  guardarDocumento = (htmlFinal, idModeloNota) => {
    let yo = this;

    if (!this.state.guardado) {
      this.props
        .insertDocumento({
          variables: {
            documento: {
              tramite: 'acuerdo_extrajudicial',
              idTramite: this.state.acuerdo._id,
              textoHtml: htmlFinal,
              idModeloNota,
            },
          },
        })
        .then(resDocumento => {
          let idDocumento = resDocumento.data.insertDocumento._id;

          this.props
            .agregarDocumento({
              variables: {
                _id: this.state.acuerdo._id,
                idDocumento,
              },
            })
            // eslint-disable-next-line no-unused-vars
            .then(resAgregarDocumento => {
              notification.success({
                message: 'Documento agregado al acuerdo',
                description:
                  'El documento se agrego correctamente al acuerdo extrajudicial',
              });

              yo.props.history.push(
                `/tramites/acuerdosExtrajudiciales/${this.state.acuerdo._id}/ver`
              );
            })
            .catch(err => {
              console.log(
                'Error a la hora de agregar el documento al acuerdo extrajudicial'
              );
              console.log(err);
            });
        })
        .catch(err => {
          console.log('Ocurrio un error a la hora de insertar el documento...');
          console.log(err);
        });
    }
  };

  crearOpciones(persona) {
    return (
      <Option key={persona._id} value={persona._id}>
        {persona.nombre + ' ' + persona.apellido}
      </Option>
    );
  }

  handleRequirenteChange = valor => {
    this.setState({
      requirenteSeleccionado: valor,
    });
  };

  handleRequeridosChange = valor => {
    this.setState({
      requeridosSeleccionados: valor,
    });
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  onCancel = () => {
    this.setState(
      {
        estado: false,
        acuerdo: {},
      },
      () => {
        this.props.history.goBack();
      }
    );
  };

  render() {
    const { Step } = Steps;
    let { step } = this.state;
    const { acuerdo } = this.state;
    let opcionesRequeridos = [];
    let opcionRequirente = [];

    if (this.state.loading) {
      return <Loading />;
    }

    if (acuerdo.requirente && acuerdo.requeridos) {
      opcionesRequeridos = _.map(acuerdo.requeridos, this.crearOpciones);
      opcionRequirente.push(this.crearOpciones(acuerdo.requirente));
    } else {
      return <Loading />;
    }

    return (
      <div>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '70vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Agregar Documento
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Seleccionar Personas" />
            <Step title="Generar Documento" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <div style={{ textAlign: 'center' }}>
                <h3>Seleccionar Requirente:</h3>
                <Row>
                  <Col span={24}>
                    <Select
                      mode="multiple"
                      style={{ width: '70%' }}
                      placeholder="Elegir Requirente"
                      onChange={this.handleRequirenteChange}
                    >
                      {opcionRequirente}
                    </Select>
                  </Col>
                </Row>

                <h3 style={{ marginTop: '125px' }}>Seleccionar Requeridos:</h3>
                <Row>
                  <Col span={24}>
                    <Select
                      mode="multiple"
                      style={{ width: '70%' }}
                      placeholder="Elegir Requeridos"
                      onChange={this.handleRequeridosChange}
                    >
                      {opcionesRequeridos}
                    </Select>
                  </Col>
                </Row>

                <Row style={{ marginTop: '100px' }}>
                  <Col span={12} offset={6}>
                    <Button
                      type="primary"
                      style={{ float: 'rigth', marginTop: 5, marginLeft: 20 }}
                      onClick={() => this.siguientePaso()}
                    >
                      Siguiente
                    </Button>
                    <Button
                      type="danger"
                      style={{ float: 'rigth', marginTop: 5, marginLeft: 20 }}
                      onClick={() => this.onCancel()}
                    >
                      Cancelar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            {step === 1 && (
              <ProcesoImprimir
                datos={this.generarDatos()}
                onImprimir={(htmlActuacion, idModeloNota) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDocumento(htmlActuacion, idModeloNota)
                  )
                }
                onGuardar={(htmlActuacion, idModeloNota) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDocumento(htmlActuacion, idModeloNota)
                  )
                }
                onCancel={this.onCancel}
                loading={this.state.loading}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(AgregarDocumento);
